import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
    const token = localStorage.getItem("rf_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// 402 → dispatch a global event so the Upgrade Nag Modal can render itself.
client.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 402) {
            const detail = err.response.data?.detail || "This feature requires a paid plan.";
            const url = err.config?.url || "";
            // Classify the block so the modal can pre-select the right target tier
            let target = "starter";
            if (/backlinks|disavow/i.test(url)) target = "agency";
            else if (/bulk-diagnose/i.test(url)) target = "pro";
            else if (/audit/i.test(url) && /audit/i.test(detail)) target = "pro";
            window.dispatchEvent(new CustomEvent("rf_upgrade_nag", { detail: { message: detail, target, url } }));
        }
        return Promise.reject(err);
    }
);

export default client;
